import { useTheme } from '@mui/material';

interface GoBackButtonIconProps {
  arrowColor?: string;
  borderColor?: string;
}

export default function GoBackButtonIcon({ arrowColor, borderColor }: GoBackButtonIconProps = {}) {
  const theme = useTheme();
  const resolvedArrowColor = arrowColor ?? theme.palette.primary.main;
  const resolvedBorderColor = borderColor ?? theme.palette.primary.light;

  return (
    <svg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='28' height='28' rx='14' transform='matrix(0 -1 -1 0 29 29)' fill='white' />
      <rect width='28' height='28' rx='14' transform='matrix(0 -1 -1 0 29 29)' stroke={resolvedBorderColor} />
      <mask id='mask0_14586_33019' maskUnits='userSpaceOnUse' x='4' y='4' width='22' height='22'>
        <rect width='21.3333' height='21.3333' transform='matrix(0 -1 -1 0 25.668 25.6641)' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_14586_33019)'>
        <path
          d='M11.0902 14.9948L16.4235 20.3281L17.668 19.0837L13.5791 14.9948L17.668 10.9059L16.4235 9.66146L11.0902 14.9948Z'
          fill={resolvedArrowColor}
        />
      </g>
    </svg>
  );
}
